import { Component } from "solid-js";

interface LuxuryIconProps {
  class?: string;
}

export const LuxuryIcon: Component<LuxuryIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M1.67529 10.543L6.67759 4.63116M1.67529 10.543L16.2274 27.3689M1.67529 10.543H11.2251M6.67759 4.63116H16.2274M6.67759 4.63116L11.2251 10.543M25.7773 4.63116L30.3248 10.543M25.7773 4.63116L20.775 10.543M25.7773 4.63116H16.2274M30.3248 10.543L16.2274 27.3689M30.3248 10.543H20.775M16.2274 27.3689L20.775 10.543M16.2274 27.3689L11.2251 10.543M20.775 10.543L16.2274 4.63116M20.775 10.543H11.2251M16.2274 4.63116L11.2251 10.543"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
